import { dataFlagSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFlagSolid = /*#__PURE__*/createIcon(dataFlagSolid)
export default IconFlagSolid
